<template>
    <div
        class="game__task-item"
        draggable="false"
        @drag.prevent.stop
        @dragstart.prevent.stop
        @dragend.prevent.stop
        v-if="task.fileUrl || task.text || task.video"
        :style="{
            '--player-color-main': getTaskAuthorColor(),
            '--player-color-contrast': getTaskAuthorContrastColor()
        }"
    >
        <template v-if="canViewTask(task)">
            <div class="game__task-image" v-if="task.fileUrl" :class="{'zoom': imageIsZoomed}">
                <img
                    :src="task.fileUrl"
                    :class="{'zoom': imageIsZoomed}"
                    alt=""
                    @load="emitImageRatio($event, taskName)"
                    @click="taskImageZoom"
                    draggable="false"
                    @drag.prevent.stop
                    @dragstart.prevent.stop
                    @dragend.prevent.stop
                    v-click-outside="taskImageResetZoom"
                >
                <div v-if="imageIsZoomed" class="cross"></div>
            </div>

            <div class="game__task-text" v-if="task.text && isCustomGame()">
                {{ task.text }}
            </div>

            <div class="game__task-text" v-if="task.text && !isCustomGame()" v-html="task.text">
            </div>

            <div class="game__task-video"  v-if="task.video">
                <iframe :id="'player_' + taskName" :src="getYoutubeEmbed(task.video)" frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                ></iframe>
            </div>
            <template v-if="task.video && isCustomGame()">
                <button class="common-btn" v-if="task.is_video_started === false" @click="playVideo(true)">Воспроизвести у всех</button>
                <button class="common-btn" v-if="task.is_video_started === true" @click="playVideo(false)">Пауза</button>
            </template>

            <div class="game__task-video" v-if="this.taskFrameSource">
                <iframe :src="this.taskFrameSource" frameborder="0"></iframe>
            </div>
        </template>
        <template v-else>
            <div class="game__task-hidden">
                <strong :style="{'color': currentPlayerColor}">{{ $t('message.task_is_hidden') }}</strong>
                <svg :style="{'fill': currentPlayerColor}" width="60" height="25" viewBox="0 0 60 25" xmlns="http://www.w3.org/2000/svg">
                    <path d="M29.9983 17.5384C20.1634 17.5384 10.3285 12.7634 0.563548 3.21602C-0.176445 2.49103 -0.188945 1.30604 0.533548 0.563548C1.25854 -0.176445 2.44353 -0.188945 3.18602 0.533548C21.2284 18.1759 38.7707 18.1759 56.813 0.533548C57.5555 -0.188945 58.743 -0.176445 59.4655 0.563548C60.1905 1.30354 60.1755 2.49103 59.4355 3.21602C49.6681 12.7634 39.8332 17.5384 29.9983 17.5384Z"/>
                    <path d="M29.998 24.9983C28.963 24.9983 28.123 24.1583 28.123 23.1233V16.2484C28.123 15.2134 28.963 14.3734 29.998 14.3734C31.033 14.3734 31.873 15.2134 31.873 16.2484V23.1233C31.873 24.1583 31.033 24.9983 29.998 24.9983Z"/>
                    <path d="M58.1224 13.391C57.5849 13.391 57.0524 13.161 56.6824 12.716L52.1825 7.32352C51.5175 6.52853 51.625 5.34604 52.42 4.68354C53.2125 4.01855 54.3999 4.12855 55.0599 4.92104L59.5599 10.3135C60.2249 11.1085 60.1174 12.291 59.3224 12.9535C58.9724 13.2485 58.5474 13.391 58.1224 13.391Z"/>
                    <path d="M1.87359 13.1235C1.4361 13.1235 0.993601 12.9685 0.638604 12.656C-0.141388 11.9735 -0.216388 10.7885 0.466106 10.0111L4.96606 4.8861C5.64606 4.10611 6.83355 4.03111 7.61104 4.7136C8.39103 5.3961 8.46603 6.58109 7.78354 7.35858L3.28358 12.4835C2.91358 12.9085 2.39359 13.1235 1.87359 13.1235Z"/>
                    <path d="M45.6231 21.2483C44.9531 21.2483 44.3031 20.8884 43.9656 20.2559L40.8406 14.3859C40.3556 13.4709 40.7006 12.3359 41.6156 11.8484C42.5231 11.3634 43.6656 11.7059 44.1531 12.6234L47.2781 18.4934C47.7631 19.4084 47.4181 20.5434 46.5031 21.0309C46.2231 21.1783 45.9231 21.2483 45.6231 21.2483Z"/>
                    <path d="M14.3735 21.2483C14.076 21.2483 13.7735 21.1783 13.4935 21.0283C12.5786 20.5408 12.2336 19.4058 12.7185 18.4908L15.8435 12.6209C16.3285 11.7059 17.466 11.3634 18.381 11.8459C19.296 12.3334 19.641 13.4683 19.156 14.3833L16.031 20.2533C15.691 20.8883 15.0435 21.2483 14.3735 21.2483Z"/>
                </svg>
            </div>
        </template>

        <button
            type="button"
            v-if="canDeleteTask(task)"
            class="game__task-delete"
            @click="deleteTask(taskName)"
        ></button>

        <control-visibility
            :player-id="playerId"
            :players="players"
            :visible-for="task.visibleFor"
            :hidePlayerEye="false"
            @change-visibility="$parent.changeTaskPlayerVisibility($event, taskName)"
            @change-visibility-all="$parent.changeTaskVisibility(taskName)"
            :overallVisibility="task.visibility"
        ></control-visibility>
    </div>
</template>

<script>
import store from "../store";
import Tools from "../helpers/Tools";
import EventApi from "../api/EventsApi";

const TASK_STATE_TYPE_CUSTOM = 2;

export default {
    props: {
        taskName: {
            required: true,
            type: String
        },
        task: {
            required: true,
            type: Object
        },
        taskSettings: {
            required: true,
            type: Object
        },
        playerId: {
            required: true,
            type: String
        },
        players: {
            required: true,
            type: Array
        },
        taskVisibility: {
            required: true,
            type: Object
        },
        disableDelete: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            taskFrameSource: null,
            imageIsZoomed: false,
            ytPlayer: null,
        }
    },
    mounted() {
        this.parseTaskText();
    },
    watch: {
        task: function(newVal, oldVal) {
            if (newVal.author && newVal.text !== oldVal.text) {
                this.parseTaskText();
            }

            if (newVal.video) {
                if ((newVal.video !== oldVal.video) || (newVal.video && !this.ytPlayer)) {
                    this.initYtPlayer();
                } else {
                    this.changeVideoStatus(newVal.is_video_started);
                }
            }
        }
    },

    computed: {
        currentPlayerColor: function () {
            let filtered = this.players.filter((item) => {
                return item.id === this.playerId;
            });

            if (typeof filtered[0] !== 'undefined') {
                return filtered[0].color.code;
            }

            return '#888';
        }
    },

    methods: {

        /**
         * Может видеть задачу
         */
        canViewTask(task)
        {
            if (task.visibility === this.taskVisibility.VISIBLE) {
                return true;
            }

            if (task.visibility === this.taskVisibility.VISIBLE_FOR && task.visibleFor.indexOf(this.playerId) !== -1) {
                return true;
            }

            return false;
        },

        /**
         * Может удалить задачу
         */
        canDeleteTask(task)
        {
            if (this.disableDelete) {
                return false;
            }

            return true;
        },

        /**
         * Обработка текста задания
         */
        parseTaskText()
        {
            this.taskFrameSource = null;

            if (this.task.text) {
                this.taskFrameSource = this.getYoutubeEmbed(this.task.text);
            }
        },

        /**
         * Embed ссылка на видео youtube
         * @param text
         */
        getYoutubeEmbed(text) {
            let youtubeMatchExp = '((?:https?:)?\\/\\/)?((?:www|m)\\.)?((?:youtube\\.com|youtu.be))(\\/(?:[\\w\\-]+\\?v=|embed\\/|v\\/)?)([\\w\\-]+)(\\S+)?';
            let youtubeMatch = text.match(youtubeMatchExp);

            if (!youtubeMatch) {
                return null;
            }

            let embed = null;

            if (typeof youtubeMatch[5] !== 'undefined') {
                embed = 'https://www.youtube.com/embed/' + youtubeMatch[5] + `?`;
            }

            if (text.indexOf('list') !== -1) {
                let playlistData = text.match('[?&]list=([^#\\&\\?]+)');
                if (typeof playlistData[1] !== 'undefined') {
                    let playlistId = playlistData[1].indexOf('PL') === 0 ? playlistData[1] : `PL${playlistData[1]}`;
                    embed = 'https://www.youtube.com/embed?listType=playlist&list=' + playlistId + `&`;
                }
            }

            if (!embed) {
                return null;
            }

            return embed + `rel=0&enablejsapi=1&origin=${location.origin}&showinfo=0`;
        },

        /**
         * Данные игрока
         * @return {null|*}
         */
        getPlayerColorById(id)
        {
            if (typeof store.getters.getPlayers !== 'undefined') {
                let players = store.getters.getPlayers;
                let player = players.filter((item) => {
                    return item.id === id;
                }).pop();

                if (typeof player === 'undefined') {
                    return null;
                }

                if (typeof player.color !== 'undefined') {
                    return player.color;
                } else {
                    return null;
                }
            }
            return null;
        },

        /**
         * Имя игрока
         * @param playerId
         * @return {null|*}
         */
        getPlayerName(playerId)
        {
            if (typeof store.getters.getGameState.playersData === "undefined") {
                return '';
            }

            let playersData = store.getters.getGameState.playersData;

            if (typeof playersData[playerId] === "undefined") {
                return '';
            }

            let playerData = playersData[playerId];

            return playerData.name;
        },

        emitImageRatio(event, taskName) {
            this.$emit('taskImageLoaded', {
                img: event.target,
                task: taskName
            });
        },

        /**
         * Цвет автора задания
         * @return {string|*}
         */
        getTaskAuthorColor()
        {
            let playerColor = this.getPlayerColorById(this.task.author);

            if (!playerColor) {
                return '#888';
            }

            return playerColor.code;
        },

        /**
         * Контрастный цвет автора задания
         * @return {string|*}
         */
        getTaskAuthorContrastColor()
        {
            let playerColor = this.getPlayerColorById(this.task.author);

            if (!playerColor) {
                return '#fff';
            }

            return playerColor.contrast;
        },

        /**
         * Сброс зума для картинок в задании
         * @param e
         */
        taskImageResetZoom(e)
        {
            this.imageIsZoomed = false;
        },

        /**
         * Зум картинки в задании по клику на картинку
         * @param e
         */
        taskImageZoom(e)
        {
            EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'zoom'});
            this.imageIsZoomed = !this.imageIsZoomed;
        },

        /**
         * Своя игра
         * @return {boolean}
         */
        isCustomGame()
        {
            return store.getters.getGameState.tasks.state.type === TASK_STATE_TYPE_CUSTOM;
        },

        /**
         * id Youtube-видео
         * @param url
         * @return {null}
         */
        getYoutubeVideoId(url)
        {
            return Tools.getYouTubeVideoId(url);
        },

        /**
         * Иниуиализация плеера youtube
         */
        initYtPlayer()
        {
            Vue.nextTick(() => {
                const playerId = 'player_' + this.taskName;
                const element = document.getElementById(playerId);
                if (element && typeof YT !== 'undefined') {
                    this.ytPlayer = new YT.Player(playerId, {});
                }
            });
        },

        /**
         * Воспроизвести видео
         */
        changeVideoStatus(status = false)
        {
            if (this.ytPlayer)
            {
                if (status) {
                    this.ytPlayer.playVideo();
                } else {
                    this.ytPlayer.pauseVideo();
                }
            }
        },

        /**
         * Запуск видео
         * @param startVideo
         */
        playVideo(startVideo)
        {
            let data = this.task;
            data.isVideoStarted = startVideo;
            data.type = this.taskName;

            EventApi.triggerEvent(EventApi.EVENT_SEND_MESSAGE, {
                type: 'setTask',
                data: data
            });
        },

        deleteTask(name)
        {
            EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
            this.$emit('deleteTask', name);
        }
    }
}
</script>
